import ScrollReveal from 'scrollreveal'
const sr = ScrollReveal({})

//Source: https://github.com/tserkov/vue-scroll-reveal. Learning how to create vue plugins
function generateOptions(defaultOptions, bindingValue, bindingModifiers) {
  const options = Object.assign({}, defaultOptions, bindingValue)

  if (bindingModifiers) {
    if (bindingModifiers.reset) {
      options.reset = true
    }

    if (bindingModifiers.nomobile) {
      options.mobile = false
    }

    if (bindingModifiers.nodesktop) {
      options.desktop = false
    }
  }

  return options
}

const VueScrollReveal = {
  install(Vue, defaultOptions) {
    Vue.directive('scroll-reveal', {
      inserted: (el, binding) => {
        const options = generateOptions(
          defaultOptions,
          binding.value,
          binding.modifiers
        )

        if (typeof options.class === 'string') {
          el.classList.add(options.class)
          delete options.class
        }

        sr.reveal(el, options)
      },
      update: (el, binding) => {
        if (binding.value != binding.oldValue) {
          const options = generateOptions(
            defaultOptions,
            binding.value,
            binding.modifiers
          )

          sr.reveal(el, options)
        }
      }
    })

    const $sr = {
      clean(el) {
        sr.clean(el)
      },
      sync() {
        sr.sync()
      },
      isSupported() {
        return sr.isSupported()
      },
      reveal(target, config, interval, sync) {
        const options = generateOptions(defaultOptions, config)
        sr.reveal(target, options, interval, sync)
      }
    }

    Object.defineProperty(Vue.prototype, '$sr', {
      get() {
        return $sr
      }
    })
  }
}

//v-scroll directive. https://vuejs.org/v2/cookbook/creating-custom-scroll-directives.html
const Scroll = {
  install(Vue) {
    Vue.directive('scroll', {
      inserted: function(el, binding) {
        let f = function(evt) {
          if (binding.value(evt, el)) {
            window.removeEventListener('scroll', f)
          }
        }
        window.addEventListener('scroll', f)
      }
    })
  }
}

export { VueScrollReveal, Scroll }
